const useGenres = (selectedGenres)=>{
  if(selectedGenres.length<1)return "";
  const genids = selectedGenres.map((g)=>g.id);
  return genids.reduce((acc,crr)=>acc+","+crr);
}
export default useGenres;